export default __webpack_public_path__ + "images/UM.cc3f636.png";